module.exports = __webpack_public_path__ + "img/logo.23449647.png";